// "Preview as this link": the owner sees exactly what a share link shows. The choice lasts for
// this tab only (sessionStorage), and every API request carries it as X-NSJ-Preview.

import { setPreviewShare } from "@/api";

const KEY = "nsj-preview";

export function restorePreview() {
  try {
    setPreviewShare(sessionStorage.getItem(KEY));
  } catch {
    setPreviewShare(null);
  }
}

export function startPreview(shareId: string) {
  try {
    sessionStorage.setItem(KEY, shareId);
  } catch {
    // Private mode: the preview lasts until the page reloads.
  }
  setPreviewShare(shareId);
}

export function stopPreview() {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    // Nothing stored.
  }
  setPreviewShare(null);
}
